function observeClientPage () {
    const store = this;
    
    window.addEventListener('message', (e) => {
        if (e.data && typeof store[e.data.action] === 'function') {
            store[e.data.action](e.data.data);
        }
    });
}

export default observeClientPage;